define([
    'jquery',
    './console',
    './globals'
], function($, console, globals) {
    'use strict';

    const videoHome = {'videoId': 'Ywh54mpo3so', 'startSeconds': 1, 'endSeconds': 99, 'suggestedQuality': 'hd1080'};
    const YouTubePlayer = require('youtube-player');
    const PlayerStates = require('youtube-player/dist/constants/PlayerStates');
    const videoStates = {
        '-1': 'unstarted',
        0: 'ended',
        1: 'playing',
        2: 'paused',
        3: 'buffering',
        5: 'video cued'
    };
    let $videoEl;
    let youTubeVideoId;
    let player;
    let onResizeTimeout;
    let playerListenerOnReady;
    let playerListenerOnAutoplayBlocked;
    let playerListenerError;
    let playerListenerStateChange;

    function initializeVideoPlayer() {
        $videoEl = $('#tv');

        if ($videoEl.length === 0) {
            return;
        }

        youTubeVideoId = $videoEl.data('video');
        console.log('youTubeVideoId: ', youTubeVideoId);

        // localStorage.debug = 'youtube-player:*';

        // @see https://developers.google.com/youtube/player_parameters
        player = YouTubePlayer('tv',
            {
                videoId: youTubeVideoId, //videoHome.videoId,
                playerVars: {
                    autoplay: 1,
                    controls: 0,
                    disablekb: 1,
                    enablejsapi: 1,
                    fs: 0,
                    iv_load_policy: 3,
                    loop: 1,
                    origin: 'https://new.dezanovehouse.com',
                    host: 'https://new.dezanovehouse.com',
                    playsinline: 1,
                    rel: 0,
                    mute: 1,
                    autohide: 1,
                    playlist: youTubeVideoId, //videoHome.videoId,
                    showinfo: 0
                }
            });

        player.on('onPlaybackQualityChange', function(event) {
            console.log('onPlaybackQualityChange event:', event);
        });

        playerListenerOnReady = player.on('onReady', function (event) {
            console.log('player.onReady:', event.target);

            adjustPlayerSize();

            const player = event.target;

            // player.loadVideoById(videoHome.videoId);
            player.mute();
            player.playVideo();
        });

        playerListenerOnAutoplayBlocked = player.on('onAutoplayBlocked', function (event) {
            console.log('player.onAutoplayBlocked', event);
        });

        playerListenerError = player.on('error', function (event) {
            console.log('player.error', event);
        });

        playerListenerStateChange = player.on('stateChange', function (event) {
            console.log('player.stateChange: ', event.target, event.data);

            if (!videoStates[event.data]) {
                throw new Error('Unknown state (' + event.data + ').');
            }

            const player = event.target;
            const playerStatus = event.data;

            adjustPlayerSize();

            console.log('State1: ' + videoStates[event.data] + ' (' + event.data + ').');

            if (playerStatus === PlayerStates.ENDED) {
                console.log('PlayerStates.ENDED');
                player.seekTo(0);
            } else if (playerStatus === PlayerStates.PLAYING) {
                console.log('PlayerStates.PLAYING');
                adjustPlayerSize();

                $('#tv').addClass('active');

                setTimeout(function () {
                    $('.home_videos').addClass('active');
                }, 1000);

            } else if (playerStatus === PlayerStates.PAUSED) {
                console.log('PlayerStates.PAUSED');
                $('#tv').removeClass('active');
                adjustPlayerSize();
                player.seekTo(videoHome.startSeconds);
            } else if (playerStatus === PlayerStates.UNSTARTED) {
                player.playVideo();
            }

            adjustPlayerSize();
            console.log('State2: ' + videoStates[event.data] + ' (' + event.data + ').');
        });

        $(window).on('resize orientationchange', onResizeHandler); // execute after timeout

        onResizeHandler();

        player
            .playVideo()
            .then(function () {
                adjustPlayerSize();
                console.log('Starting to play player1. It will take some time to buffer video before it starts playing.');
            });
    }

    function onResizeHandler() {
        clearTimeout(onResizeTimeout);
        onResizeTimeout = setTimeout(adjustPlayerSize, 20);
    }

    function adjustPlayerSize() {
        const $videoWrapper = $('.video_wrapper');
        const $iframe = $('#tv');
        const aspectRatio = 16 / 9; // 1.9 //2800/1471

        if ($iframe.length === 0) {
            console.log('$iframe.length === 0');
            return;
        }

        const w = $videoWrapper.outerWidth(),// + 120,
            h = $videoWrapper.outerHeight();// + 120;

        if (w / h > aspectRatio) {
            // console.log('>> adjustPlayerSize() // wide screen');

            if (player && "setSize" in player) {
                player.setSize(w, w / aspectRatio);
            }

            let newHeight = (h - $iframe.height()) / 2;
            // console.log('  top: ' + newHeight);
            // console.log('  w: ' + w + '; video-width: ' + w);
            // console.log('  h: ' + h + '; video-height: ' + w / aspectRatio);

            $iframe.width(w);
            $iframe.height(w / aspectRatio); //w/2800*1471

            $iframe.css({'left': '0px', 'top': newHeight + 'px'});

        } else {
            // console.log('adjustPlayerSize() // tall screen');

            if (player && "setSize" in player) {
                player.setSize(h * aspectRatio, h);
            }

            let newLeft = (w - $iframe.width()) / 2;
            // console.log('  left: ' + newLeft);
            // console.log('  w: ' + w + '; video-width: ' + w);
            // console.log('  h: ' + h + '; video-height: ' + w / aspectRatio);

            $iframe.css({'top': '0px', 'left': newLeft + 'px'});
            $iframe.width(h * aspectRatio);
            $iframe.height(h);
        }
    }

    const activate = function() {
        initializeVideoPlayer();
    }

    const deactivate = function() {
        if (player) {
            player.off(playerListenerOnReady);
            player.off(playerListenerOnAutoplayBlocked);
            player.off(playerListenerError);
            player.off(playerListenerStateChange);
        }

        $(window).off('resize orientationchange', onResizeHandler); // execute after timeout
    }

    return {
        activate: activate,
        deactivate: deactivate
    }
});